let options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1,
};

// カウントアップの関数
function animateCounter(element) {
  $(element)
    .prop("Counter", 0)
    .animate(
      {
        Counter: $(element).text(),
      },
      {
        duration: 2000,
        easing: "swing",
        step: function (now) {
          $(this).text(now.toFixed(1));
        },
      }
    );
}

let observer = new IntersectionObserver(function (entries, observer) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      animateCounter(entry.target);
      observer.unobserve(entry.target);
    }
  });
}, options);

// $(".counter-count").each(function () {
//   observer.observe(this);
// });
